/* eslint-disable import/prefer-default-export */
export const FILTER_TYPE = {
  FILTER: 'filter',
  STATUS: 'status',
  RATING: 'rating',
}
export const FILTER_DROPDOWN_TYPE = {
  LIST: 'list',
  CHOOSING: 'choosing',
  DATE: 'date',
}
export const NORMAL_DATE_FORMAT = 'DD/MM/YYYY';

export const DEFAULT_VALUE= "/"